module.exports = __webpack_public_path__ + "static/img/sm8.4c4437d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm8.jpg
// module id = ZV3m
// module chunks = 1